import React from 'react';

const SvgBe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BE_svg__b" fill="#fff">
        <use xlinkHref="#BE_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BE_svg__a" />
      <path fill="#FF4453" mask="url(#BE_svg__b)" d="M13.333 0H28v20H13.333z" />
      <path fill="#262626" mask="url(#BE_svg__b)" d="M0 0h9.333v20H0z" />
      <path
        fill="#FFCF3C"
        mask="url(#BE_svg__b)"
        d="M9.333 0h9.333v20H9.333z"
      />
    </g>
  </svg>
);

export default SvgBe;
